export default __webpack_public_path__ + "static/media/mobi-trustedDevActive.5f5dc0db.svg";